type SearchProps = {
  value?: any;
  onChange?: any;
  title?: string;
};

// Search.jsx
export const Search = ({ props = {} as SearchProps }: { props?: SearchProps }) => {
  const { value, onChange, title = "Search" } = props;

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-3">
      <label htmlFor="search" className="block text-[11px] font-semibold text-gray-700 mb-1">
        {title}
      </label>

      <div className="relative">
        {/* Icon (doesn't intercept clicks) */}
        <svg
          className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400"
          fill="none" viewBox="0 0 24 24" stroke="currentColor"
          aria-hidden="true"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
            d="M21 21l-4.35-4.35M10.5 18a7.5 7.5 0 100-15 7.5 7.5 0 000 15z" />
        </svg>

        <input
          id="search"
          type="text"
          placeholder="Search here..."
          className="w-full rounded-lg border border-gray-200 bg-white pl-10 pr-3 py-3 text-xs font-medium text-gray-900 placeholder:text-gray-400 outline-none focus:ring-2 focus:ring-gray-300 focus:border-gray-300"
          // Controlled only if a value is provided, otherwise uncontrolled
          {...(value !== undefined ? { value } : {})}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

type MySearchProps = {
  type?: string;
  value?: any;
  setValue?: (v: any) => void;
  onChange?: any;
};

export const MySearch = ({ type, value, setValue, onChange }: MySearchProps) => {
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-3">
      <div className="relative">
        <svg
          className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400"
          fill="none" viewBox="0 0 24 24" stroke="currentColor"
          aria-hidden="true"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
            d="M21 21l-4.35-4.35M10.5 18a7.5 7.5 0 100-15 7.5 7.5 0 000 15z" />
        </svg>

        <input
          id="search"
          type="text"
          placeholder="Context search here..."
          className="w-full rounded-lg border border-gray-200 bg-white pl-10 pr-10 py-3 text-xs font-medium text-gray-900 placeholder:text-gray-400 outline-none focus:ring-2 focus:ring-gray-300 focus:border-gray-300"
          {...(value !== undefined ? { value } : {})}
          onChange={onChange}
        />

        {/* Optional clear button if you’re passing setValue */}
        {typeof setValue === "function" && (value?.length ?? 0) > 0 && (
          <button
            type="button"
            onClick={() => setValue("")}
            aria-label="Clear search"
            className="absolute right-2 top-1/2 -translate-y-1/2 rounded-md px-2 py-1 text-[10px] font-semibold text-gray-600 hover:bg-gray-100"
          >
            Clear
          </button>
        )}
      </div>
    </div>
  );
};
